import React from "react";

export const BannerContext = React.createContext(null)
